import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Inbox } from "@mui/icons-material";

/**
 * Reusable EmptyState component for displaying "no data" messages
 * 
 * @param {string} title - Title text
 * @param {string} message - Description message
 * @param {ReactNode} icon - Custom icon (default: Inbox)
 * @param {string} actionLabel - Action button label
 * @param {Function} onAction - Action button click handler
 * @param {Object} sx - Custom styles
 */
const EmptyState = ({
  title = "No data available",
  message = "There are no items to display at this time.",
  icon,
  actionLabel,
  onAction,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 2,
        textAlign: "center",
        ...sx,
      }}
    >
      {icon || (
        <Inbox
          sx={{
            fontSize: 64,
            color: "text.secondary",
            mb: 2,
            opacity: 0.5,
          }}
        />
      )}
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        {message}
      </Typography>
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyState;

